//import perfilEmpleadoEnumerators from 'src/modules/perfilEmpleado/perfilEmpleadoEnumerators';

// const labelOf = (name) => {
//   const field = perfilEmpleadoImporterFields.find((field) => field.name === name);
//   if (field) {
//     let label = field.label;
//     if (label && label.substr(label.length - 1) === '*') return label.slice(0, -1);
//     return label;
//   }
//   return name;
// };
const valoresHeader: any = [];
let valoresPermitidos: any = {};

// Esto es para poner los enumerator en una hoja aparte
// Object.keys(perfilEmpleadoEnumerators).forEach((key) => {
//   if (key !== 'tipoDepreciacion') {
//     const header = labelOf(key);
//     valoresHeader.push(header);
//     valoresHeader.push('');
//     perfilEmpleadoEnumerators[key].forEach((valor, index) => {
//       if (!valoresPermitidos[index]) valoresPermitidos[index] = {};
//       valoresPermitidos[index][header] = valor;
//     });
//   }
// });
valoresPermitidos = Object.keys(valoresPermitidos).map((key) => valoresPermitidos[key]);
const options: any = {
  withLocalizacion: true,
  withPuestos: true,
  withUsuarios: true,
  //   appendSheets: [
  //     {
  //       name: 'tipos_validos',
  //       json: valoresPermitidos,
  //       header: valoresHeader,
  //       skipHeader: false,
  //     },
  //   ],
};
export default options;
